import { SagaRegistry, ReducersRegistry } from '@grandvisionhq/state';
import prescriptionGlassesReducer from './state/reducer.js';
import prescriptionGlassesSaga from './state/sagas.js';
export { RxGlassesConfigurator } from './configurator/RxGlassesConfigurator.js';
export { RxConfiguratorSlotsProvider, useRxConfiguratorSlots } from './slots/context.js';

SagaRegistry.register('prescriptionGlasses', prescriptionGlassesSaga);
ReducersRegistry.register('prescriptionGlasses', prescriptionGlassesReducer);
//# sourceMappingURL=index.js.map
